import React from 'react';
import {ServerComponentCaller} from "../../helpers";

const LicenciaClaseA5 = props => <ServerComponentCaller url={"assets/data/pages/licencias/A5.json"}/>

export default LicenciaClaseA5;
